module.exports = __webpack_public_path__ + "img/avatar.996bf75e.png";